import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { StandaloneLinkResolver } from '../core';

import { StandaloneLinkComponent } from './standalone-link/standalone-link.component';

const routes: Route[] = [
    { path: 'watch', component: StandaloneLinkComponent, resolve: { courses: StandaloneLinkResolver } }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class StandaloneRouting {}